import PropTypes from "prop-types";

import {
    Modal,
    Button,
    CustomContainer
} from "components/atoms/DependencyHelper";
import Image from "components/atoms/image/image";

import {
    componentCheckSize,
    createMarkup
} from "utils/helperServices";

import config from "../../../config/index";

import styles from "./upgradeErrorModal.module.scss";

const upgradeErrorModal = ({
                               show,
                               text,
                               type,
                               title,
                               subText,
                               nextDate,
                               cellphone,
                               cancelLabel,
                               handleCancel,
                               primaryLabel,
                               handleRestart,
                               secondaryLabel,
                               solidBlackBtnLabel,
                               solidBlackBtnAction,
                               handlePrimaryAction,
                               outlineWhiteBtnLabel,
                               outlineWhiteBtnAction,
                               handleSecondaryAction,
                               solidBlackBtnLabelSecond
                           }) => {
    const env = config.env;
    const imagePrefix = config.envConfigs[env].imagePrefix;
    const isMobile = componentCheckSize() < 768;

    let imgUrl;

    switch (type) {
        case "sucess":
            imgUrl = `${imagePrefix}/assets/images/icon-sucess.svg`;
            break;
        case "error":
            imgUrl = `${imagePrefix}/assets/images/icon-cross.svg`;
            break;
        case "info":
            imgUrl = `${imagePrefix}/assets/images/icon-info.svg`;
            break;
        case "telephonic":
            imgUrl = `${imagePrefix}/assets/images/deal-builder/call.svg`;
            break;
        default:
            imgUrl = isMobile ?
                `${imagePrefix}/assets/images/deal-builder/product-search.svg` :
                `${imagePrefix}/assets/images/deal-builder/question.svg`;
            break;
    }

    return (
        <>
            <Modal
                show={show}
                dialogClassName={`${styles["upgrade-error-modal"]}`}
                onHide={handleCancel}
                centered
            >
                <Modal.Header className={styles["modal-header"]}>
                    <Image
                        className={styles["close-button"]}
                        img_path={`${imagePrefix}/assets/images/deal-builder/close-small.svg`}
                        onClick={handleCancel}
                    />
                </Modal.Header>
                <Modal.Body className={styles["modal-body"]}>
                    <div className={styles["icon"]}>
                        <Image
                            className={styles["icon-cross"]}
                            img_path={imgUrl}
                        />
                    </div>

                    {title && (
                        <CustomContainer className={styles["title"]} id={`${title}-heading`}>
                            { title }
                        </CustomContainer>
                    )}

                    <CustomContainer
                        className={styles["content"]}
                        dangerouslySetInnerHTML={createMarkup(text.replace("{{cellphone}}", cellphone))}
                        id={`${title}-desc`}
                    />

                    {nextDate && (
                        <CustomContainer className={styles["nextDate"]} id={`${nextDate}-text`}>
                            { nextDate }
                        </CustomContainer>
                    )}

                    {((!primaryLabel && !secondaryLabel) || (!primaryLabel && !cancelLabel)) && (
                        <CustomContainer className={styles["subText"]} id={`${subText}-text`}>
                            { subText }
                        </CustomContainer>
                    )}
                </Modal.Body>

                {(primaryLabel || secondaryLabel || cancelLabel || solidBlackBtnLabel) && (

                    <Modal.Footer className={styles["modal-footer"]}>
                        {primaryLabel && (
                            <Button onClick={handlePrimaryAction} className={`${styles["primary"]}`} id={`${primaryLabel}-btn`}>
                                {primaryLabel}
                            </Button>
                        )}

                        {secondaryLabel && (
                            <Button onClick={handleSecondaryAction} className={`${styles["secondary"]}`} id={`${secondaryLabel}-btn`}>
                                {secondaryLabel}
                            </Button>
                        )}

                        {cancelLabel && (
                            <Button onClick={handleCancel} className={`${styles["cancel"]}`} id={`${cancelLabel}-btn`}>
                                {cancelLabel}
                            </Button>
                        )}

                        {solidBlackBtnLabel && (
                            <Button onClick={solidBlackBtnAction} className={`${styles["cancelUpgradeBttn"]} new-contract`} id={`${solidBlackBtnLabel}-btn`}>
                                <span>{solidBlackBtnLabel}</span>
                            </Button>
                        )}

                        {solidBlackBtnLabelSecond && (
                            <Button onClick={handleRestart} className={`${styles["cancelUpgradeBttn"]} another-number`} id={`${solidBlackBtnLabelSecond}-btn`}>
                                <span>{solidBlackBtnLabelSecond}</span>
                            </Button>
                        )}

                        {outlineWhiteBtnLabel && (
                            <Button onClick={outlineWhiteBtnAction} className={`${styles["cancelUpgradeBttn"]} cancel-upgrade`} id={`${outlineWhiteBtnLabel}-btn`}>
                                <span>{outlineWhiteBtnLabel}</span>
                            </Button>
                        )}
                    </Modal.Footer>
                )}
            </Modal>
        </>
    );
};

upgradeErrorModal.propTypes = {
    show: PropTypes.bool,
    text: PropTypes.string,
    type: PropTypes.string,
    title: PropTypes.string,
    subText: PropTypes.string,
    nextDate: PropTypes.string,
    cellphone: PropTypes.string,
    cancelLabel: PropTypes.string,
    primaryLabel: PropTypes.string,
    secondaryLabel: PropTypes.string,
    handleCancel: PropTypes.func,
    handleRestart: PropTypes.func,
    solidBlackBtnLabel: PropTypes.string,
    solidBlackBtnAction: PropTypes.func,
    outlineWhiteBtnLabel: PropTypes.string,
    outlineWhiteBtnAction: PropTypes.func,
    handlePrimaryAction: PropTypes.func,
    handleSecondaryAction: PropTypes.func,
    solidBlackBtnLabelSecond: PropTypes.string
};

upgradeErrorModal.defaultProps = {
    title: "Technical Error"
};

export default upgradeErrorModal;
